// returns main SUBDOMAIN URL for calling API calls, example: "corpo1.get-local.tech"
export const getMainSubdomainUrl = (currentHostname: string, defaultDomain: string): string => {
  if (currentHostname.includes("localhost")) {
    const params = new URLSearchParams(window.location.search);
    const platformOverride = params.get("platform");
    if (platformOverride === "airline" && currentHostname === "localhost") {
      return `dev.airline.${defaultDomain}`;
    }
    return currentHostname.replace("localhost", defaultDomain);
  } else {
    return currentHostname;
  }
};
